import type { FC } from 'react';
import { ExclamationIcon } from '@heroicons/react/solid';

export const WarningBanner: FC = () => (
  <div className="flex items-start gap-x-3 rounded-md bg-amber-50 p-4" data-testid="warning-banner">
    <div>
      <ExclamationIcon className="h-5 w-5 text-amber-600" aria-hidden="true" />
    </div>
    <p className="text-sm leading-5 font-medium text-amber-800">
      Changing the template for this renewal contract will reset any edited content, including additional text and
      formatting changes.
    </p>
  </div>
);
